import { render } from "./Priest.vue?vue&type=template&id=63b5e676"
import script from "./Priest.vue?vue&type=script&lang=js"
export * from "./Priest.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\website_tow\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__